/**
 * RequestTimeout.
 * @module components/theme/RequestTimeout/RequestTimeout
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Container } from 'semantic-ui-react';

/**
 * @function RequestTimeout
 * @returns {string} Markup of the not found page.
 */
const RequestTimeout = () => (
  <Container className="view-wrapper error-page">
    <h3>
      <FormattedMessage
        id="No connection to the server"
        defaultMessage="There is no connection to the server, due to a timeout or no network connection."
      />
    </h3>
    <p style={{ textAlign: 'center' }}>
      <FormattedMessage
        id="Please check your connection and try again."
        defaultMessage="Please check your connection and try again."
      />
    </p>
  </Container>
);

export default RequestTimeout;
